<ng-container *ngIf="returnRequest$ | async as returnRequest">
  <div class="cx-nav row">
    <div class="col-xs-12 col-md-4 col-lg-3">
      <button (click)="back()" class="btn btn-block btn-action">
        {{ 'common.back' | cxTranslate }}
      </button>
    </div>

    <div class="col-xs-12 col-md-4 col-lg-3">
      <button
        *ngIf="returnRequest.cancellable"
        class="btn btn-block btn-primary"
        (click)="cancelReturn(returnRequest.rma)"
        [disabled]="isCancelling$ | async"
      >
        {{ 'returnRequest.cancel' | cxTranslate }}
      </button>
    </div>
  </div>
  <div class="cx-header row">
    <div class="cx-detail col-sm-12 col-md-4">
      <div class="cx-detail-label">
        {{ 'returnRequest.returnRequestId' | cxTranslate }}
      </div>
      <div class="cx-detail-value">{{ returnRequest.rma }}</div>
    </div>
    <div class="cx-detail col-sm-12 col-md-4">
      <div class="cx-detail-label">
        {{ 'returnRequest.orderCode' | cxTranslate }}
      </div>
      <div class="cx-detail-value">{{ returnRequest.order?.code }}</div>
    </div>
    <div class="cx-detail col-sm-12 col-md-4">
      <div class="cx-detail-label">
        {{ 'returnRequest.status' | cxTranslate }}
      </div>
      <div class="cx-detail-value">
        {{
          'returnRequestList.statusDisplay_' + returnRequest?.status
            | cxTranslate
        }}
      </div>
    </div>
  </div>
</ng-container>
